/**
 * this file is manually typed
 * do not install types for this import (@types/autosuggest-highlight)
 * see https://dev.azure.com/TalentMesh/TalentMesh/_workitems/edit/5280/
 * it will slow down build time, up to 10x slower than normal
 * */
// @ts-ignore
import parse from 'autosuggest-highlight/parse';

export interface MatchResult {
    text: string;
    highlight: boolean;
    key: string;
}

function parseWithKey(text: string, matches: [number, number][]): MatchResult[] {
    const tokens: Array<{ text: string; highlight: boolean }> = parse(text, matches);
    return tokens.map((token, index) => ({
        key: `${index}-${token.text}`,
        ...token,
    }));
}

export default parseWithKey;
